import { slugify } from 'transliteration';
export var covertStringToSlug = function covertStringToSlug(str) {
  if (!str) return '';
  return slugify(str);
};